<!--个人中心-->
<template>
  <div class="home-main personalCenter" v-loading="loading" :element-loading-text="loadingText">
    <div class="main_title">
      <span class="title-cn">个人中心</span>
      <span class="title-en">/Personal Center</span>
    </div>
    <div class="main-container" style="overflow-y: auto;">
      <div style="padding-bottom:120px;">
        <el-form
        :model="personalForm"
        ref="personalForm"
        :rules="personalRules"
        :label-position="labelPosition"
        class="chang_personal"
      >
        <el-form-item label="修改资料" label-width="800px" class="chang_title"></el-form-item>
        <el-form-item label="用户名" prop="username" label-width="200px" label-height="40px">
          <el-input
            v-model="username"
            type="text"
            auto-complete="off"
            placeholder="用户名"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email" label-width="200px">
          <el-input
            v-model="personalForm.email"
            type="text"
            auto-complete="off"
            placeholder="请填写正确的邮件地址"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="real_name" label-width="200px">
          <el-input
            v-model="personalForm.real_name"
            type="text"
            auto-complete="off"
            placeholder="请填写真实姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="移动电话" prop="mobile" label-width="200px">
          <el-input
            v-model="personalForm.mobile"
            type="text"
            auto-complete="off"
            placeholder="请填写正确的手机号，以方便以后接收代理商培训、产品授权等通知信息"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note" label-width="200px">
          <el-input
            v-model="personalForm.note"
            type="text"
            auto-complete="off"
            placeholder
            clearable
          ></el-input>
        </el-form-item>
        <div class="btn_group">
          <el-button
            class="primary submit_personal"
            @click="showChangePwd()"
            :loading="loading"
          >修改密码</el-button>
          <el-button class="primary submit_personal" @click="save" :loading="loading">保存</el-button>
        </div>
        </el-form>
        <!-- <OEM></OEM> -->
      </div>
    </div>
    <!-- 修改密码 -->
    <el-dialog top="0" title="修改密码" :visible.sync="changePwdVisible" width="550px">
      <el-form
        :model="formUser"
        ref="formUser"
        :rules="formRulesUser"
        :label-width="formLabelWidth"
      >
        <el-form-item prop="password" label="旧密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="formUser.o_password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="新密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="formUser.n_password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="password_confirm" label="确认密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="formUser.password_confirm" placeholder="请再次输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="me_font14" type="primary" size="small" @click="submitFormPwd()">保存</el-button>
        <el-button class="me_font14" size="small" @click="changePwdVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isvalidPhone } from "../../assets/js/validate";
import { updateProfile, change_password } from "@/api/user";
import OEM from './OEM'
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formUser.password_confirm !== "") {
          this.$refs.ruleForm.validateField("password_confirm");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formUser.n_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    //手机号验证
    let validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!isvalidPhone(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
      }
    };

    //固话验证
    var validtelePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入固话号码"));
      } else {
        if (value !== "") {
          var reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
          if (!reg.test(value)) {
            callback(new Error("请输入正确格式的固话号码"));
          }
        }
        callback();
      }
    };

    return {
      loading: false,
      loadingText:"",
      labelPosition: "left",
      username: "tizdata",
      changePwdVisible: false,
      formLabelWidth: "120px",
      personalForm: {
        real_name: "",
        mobile: "",
        email: "",
        note: ""
      },
      personalRules: {
        real_name: [
          {
            required: true,
            message: "请设置用户名",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur"
          }
        ],
        // telephone: [{
        // 	required: true,
        // 	trigger: 'blur',
        // 	validator: validtelePhone
        // }],
        mobile: [
          {
            required: true,
            trigger: "blur",
            validator: validPhone
          }
        ]
      },
      formUser: {
        o_password: "",
        n_password: "",
        password_confirm: ""
      },
      formRulesUser: {
        o_password: [
          {
            required: true,
            message: "旧密码不能为空",
            trigger: "blur"
          }
        ],
        n_password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          },
          { validator: validatePass, trigger: "blur" }
        ],
        password_confirm: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          {
            validator: validatePass2,
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("user/userinfo")
      .then(() => {
        this.loading = false;

        this.personalForm = this.$store.getters.userInfo.profile;
        this.username = this.$store.getters.userInfo.username;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  methods: {
    showChangePwd() {
      this.changePwdVisible = true;
    },
    // 修改密码 点击提交保存
    submitFormPwd() {
      let self = this;
      this.$refs["formUser"].validate(valid => {
        if (valid) {
          let obj = {};
          obj.o_password = this.formUser.o_password;
          obj.n_password = this.formUser.n_password;
          change_password(obj)
            .then(response => {
              this.$message.success("修改密码成功！");
              this.changePwdVisible = false;
              setTimeout(() => {
                this.$store.dispatch("user/logout").then(() => {
                  this.$router.push({ path: "/login" });
                });
              }, 1000);
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    save() {
      this.$refs.personalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          updateProfile(this.personalForm)
            .then(() => {
              this.loading = false;
              this.$message({
                type: "success",
                message: "保存成功"
              });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components:{
    OEM
  }
};
</script>

<style lang='scss'>
.chang_personal {
  /*margin: auto;*/
  margin-top: 31px;
  margin-left: 41px;
  width: 800px;
}
.chang_title .el-form-item__label {
  font-size: 14px !important;
  background-color: #d3e4f4 !important;
}

.chang_personal .el-form-item__label {
  padding-left: 35px;
  line-height: 38px;
  background-color: #f9f9f9;
  border: 1px solid #dcdfe6;
  font-size: 12px;
}

.chang_personal .el-form-item {
  margin-bottom: 0px;
}

.chang_personal .el-form-item .el-form-item__content {
  line-height: normal;
}

.chang_personal .el-form-item.is-success .el-input__inner,
.chang_personal .el-form-item.is-error .el-input__inner {
  border-color: #dcdfe6;
}

.chang_personal .el-input__inner {
  border-radius: 0px;
}

.chang_personal .el-input {
  font-size: 12px;
}

.select_industry {
  width: 600px;
}

.select_address {
  width: 600px;
}

.chang_personal .el-form-item__error {
  position: inherit;
  height: 20px;
  line-height: 20px;
  padding-top: 0px;
  padding-bottom: 5px;
}

/*.submit_main {
		margin: auto;
		margin-right: 0px;
	}*/

.submit_personal {
  margin-top: 47px !important;
  //margin-left: 697px !important;
  padding: 0px !important;
  width: 103px !important;
  height: 34px !important;
  /*line-height: 34px;*/
  background-color: #3887cc;
  border-radius: 2px;
  border: solid 1px #e5e5e5;
}

.submit_personal span {
  /*line-height: 34px;*/
}
.personalCenter {
  .btn_group {
    text-align: right;
  }
  .submit_personal {
    margin-left: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/my/personalCenter.vue